<template>
    <aside class="large">
        <div class="sidebar__logo logo" @click="navigateToMain()">
            <img alt="Vue logo" src="@/assets/logo.png" height="40" />
            <div class="logo-name">
                <span :style="{ color: 'black' }">
                    ФЕДЕРАЦИЯ НАСТОЛЬНОГО ТЕННИСА РОССИИ
                </span>
            </div>
        </div>
        <nav>
            <TieredMenuItem orientation="vertical" :model="navigation" />
        </nav>
    </aside>
</template>

<script>
import { navigation } from "@/data/naviagation";

export default {
    emits: ["openSidebar"],
    name: "u-sidebar",
    data() {
        return {
            navigation: [],
        };
    },
    created() {
        this.navigation = navigation;
    },
    methods: {
        /**
         * Перебрасывает пользователя на главную страницу при клике на логотип
         */
        navigateToMain() {
            this.$router.push({ name: "Home" });
        },
    },
};
</script>
